module.exports = __webpack_public_path__ + "assets/img/arrow-down.15251d3f.svg";